interface PostTitleProps {
  children: string
}
const PostTitle: React.FC<PostTitleProps> = ({ children }) => (
  <h1
    dangerouslySetInnerHTML={{ __html: children }}
    className='mx-auto max-w-5xl text-3xl font-bold leading-9 text-gray-900 sm:text-4xl sm:leading-10'
  />
)

export default PostTitle
